import styled from 'styled-components';

export const FooterMainWrap = styled.div(
  props => `
      direction: ltr;
      width:100%;
      display: flex;
      background-color: ${props.theme.colors.black.base};
      align-items: center;
      padding: ${props.theme.spacing.large.l30} 0;
      @media only screen and (min-width:320px) and (max-width: 1023px){
        display: none;
      }
    `,
);

export const FooterInnerWrap = styled.div(
  props => `
      max-width: 1200px;
      margin: 0 auto;
      width:100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-direction: column;
    `,
);

export const FooterInnerMainWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    `,
);

export const FooterRowWrap = styled.div(
  props => `
        width:33%;
        display: flex;
        flex-direction: column;
    `,
);

export const FooterContentWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `,
);

export const ListContentHead = styled.div(
  props => `
        display: flex;
        padding-bottom: ${props.theme.spacing.large.l20};
    `,
);

export const ListContentHeadText = styled.p(
  props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `,
);

export const FooterContentList = styled.ul(
  props => `
        width:100%;
        display: flex;
        flex-direction: column;

        li{
            display: flex;
            padding-bottom: ${props.theme.spacing.base};
            
            a{
                font-size: ${props.theme.font.large.font14};
                color: ${props.theme.colors.white.base};
                text-decoration: none;

                &:hover{
                    color: ${props.theme.colors.white.base};
                }
            }
        }
    `,
);

export const CopyRightText = styled.p(
  props => `
      align-self: flex-end;
      display: flex;
      font-size: ${props.theme.font.large.font16};
      color: ${props.theme.colors.white.base};
      font-weight: ${props.theme.font.fontWeight.black};
      padding-top: ${props.theme.spacing.large.l50};
      padding-bottom: ${props.theme.spacing.large.l20};
    `,
);
